/**
 * Lista de albaranes relacionados con posibilidad de carga individual
 */
import React, { useState } from "react";
import {
    Card,
    CardContent,
    Box,
    Typography,
    CircularProgress,
    List,
    ListItem,
    ListItemButton,
    ListItemText
} from "@mui/material";
import ReceiptIcon from "@mui/icons-material/Receipt";
import useSalesOrder from "../../hooks/useSalesOrder";
import { OrderType } from "../../../../models/Order";

const ListOrderInfo = (props) => {
    const { getSales } = useSalesOrder();
    const [loadingIndex, setLoadingIndex] = useState(null);

    const handleClick = async (order, index) => {
        setLoadingIndex(index);
        getSales(order, 1, OrderType.Albaran.valueOf()).then(() => {
            setLoadingIndex(null);
            props.onActualizarOrderTypeText();
        });
    };

    if (props.listOrderInfo.length === 0) {
        return null;
    }

    return (
        <Card
            id="list-order-info"
            sx={{
                mb: 3,
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                borderRadius: 2
            }}
        >
            <Box
                sx={{
                    p: 2,
                    backgroundColor: "#f8f9fa",
                    borderBottom: "1px solid #e9ecef",
                    display: "flex",
                    alignItems: "center",
                    gap: 1
                }}
            >
                <ReceiptIcon sx={{ fontSize: 20, color: "#495057" }} />
                <Typography
                    sx={{
                        fontWeight: 700,
                        fontSize: 15,
                        color: "#212529"
                    }}
                >
                    Albaranes
                </Typography>
            </Box>
            <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
                <List sx={{ py: 0 }}>
                    {props.listOrderInfo.map((order, index) => (
                        <ListItem
                            key={index}
                            disablePadding
                            sx={{
                                borderBottom:
                                    index < props.listOrderInfo.length - 1
                                        ? "1px solid #e9ecef"
                                        : "none"
                            }}
                        >
                            <ListItemButton
                                onClick={() => handleClick(order, index)}
                                disabled={loadingIndex === index}
                                sx={{
                                    py: 1.5,
                                    px: 2,
                                    "&:hover": {
                                        backgroundColor: "#f8f9fa"
                                    }
                                }}
                            >
                                <ListItemText
                                    primary={order}
                                    primaryTypographyProps={{
                                        sx: {
                                            fontSize: 14,
                                            fontWeight: 500,
                                            color: "#212529"
                                        }
                                    }}
                                />
                                {loadingIndex === index && (
                                    <CircularProgress
                                        size={18}
                                        sx={{
                                            ml: 1,
                                            color: "#cc071e"
                                        }}
                                    />
                                )}
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>
            </CardContent>
        </Card>
    );
};

export default ListOrderInfo;